import { useState, useCallback } from 'react';

function useFlag(initialState) {
  const [flag, setFlag] = useState(initialState);
  return [
    flag,
    {
      enable: useCallback(() => setFlag(true), []),
      disable: useCallback(() => setFlag(false), [])
    }
  ];
}

export { useFlag };
//# sourceMappingURL=useFlag.js.map
